module.exports = __webpack_public_path__ + "media/src/website/images/locations/taching/taching_01-059289dca2df611dba628a960a4c2895.jpg";